import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Agency')
export class Agency {
  @JsonProperty('agencyCode', String, true)
  public id = '';

  @JsonProperty('streetNumberAndName', String, true)
  public address = '';

  @JsonProperty('postalCode', String, true)
  public zipCode = '';

  @JsonProperty('city', String, true)
  public city = '';

  @JsonProperty('collaboratorPhone', String, true)
  public collaboratorPhone = '';

  @JsonProperty('collaboratorMobilePhone', String, true)
  public collaboratorMobilePhone = '';

  @JsonProperty('crcAddress', String, true)
  public complaintDepartment = '';

  public get fullAddress(): string {
    if (!this.address || !this.zipCode || !this.city) {
      return '';
    }

    return `${this.address},<br />${this.zipCode} ${this.city}`;
  }

  public get phone(): string {
    return this.collaboratorPhone || this.collaboratorMobilePhone;
  }
}
